import { render, staticRenderFns } from "./GjwLoading.vue?vue&type=template&id=2a9e0540&scoped=true&"
import script from "./GjwLoading.vue?vue&type=script&lang=js&"
export * from "./GjwLoading.vue?vue&type=script&lang=js&"
import style0 from "./GjwLoading.vue?vue&type=style&index=0&id=2a9e0540&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a9e0540",
  null
  
)

export default component.exports